import axios from "axios";

class VerifyService1 {
  async send(values: {
    year: number;
    type: string;
    sendBy: string;
    pathFile: string;
    curriculum: number;
    report: string;
    open: number;
    verify: number;
  }) {
    // console.log(values);

    return await axios.post(`verify`, values);
  }

  async getdata(values: {
    type: string;
    year: number;

    curriculum: number;
  }) {
    return await axios.post(`verify/getdata`, values);
  }
  async onDelete(id: number) {
    return await axios.delete(`verify/${id}`);
  }
}

const VerifyService = new VerifyService1();
export default VerifyService;
